const _excluded = ["rtl", "mostPopularText", "setValue", "setIsOpened", "fieldValue"],
  _excluded2 = ["asAMetroChild", "firstInGroup"],
  _excluded3 = ["asAMetroChild", "firstInGroup"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './LocationSelect.css';
import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as MyLocationIcon } from '../../../resources/icons/my-location.svg';
import { ReactComponent as IconArrowLeft } from '../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../resources/icons/IconArrowRight.svg';
import { ReactComponent as IconPlane } from '../../../resources/icons/iconPlane.svg';
import { ReactComponent as IconEnterLeft } from '../../../resources/icons/IconArrowEnterLeft.svg';
import { ReactComponent as IconEnterRight } from '../../../resources/icons/IconArrowEnterRight.svg';
/* import { canUseDOM } from '../../../utils'; */

const Destinations = _ref => {
  let {
    buttonText,
    optionsNumber,
    dropDownOpened,
    children
  } = _ref;
  const [showMore, setShowMore] = useState(false);
  useEffect(() => {
    setShowMore(optionsNumber > 20);
  }, [optionsNumber, dropDownOpened]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `${showMore ? 'location-select__options-wrapper--shortened-view' : ''}`
  }, children), showMore && /*#__PURE__*/React.createElement("button", {
    className: "location-select__more-btn",
    onClick: () => {
      setShowMore(false);
    }
  }, buttonText));
};
const AirprtItem = props => {
  const {
      rtl,
      mostPopularText,
      setValue,
      setIsOpened,
      fieldValue
    } = props,
    locationProps = _objectWithoutProperties(props, _excluded);
  const {
    firstInGroup,
    isPopularHeader,
    value,
    Name,
    popularItem,
    groupLabel,
    asAMetroChild,
    city,
    country,
    airportCode
  } = locationProps;
  return /*#__PURE__*/React.createElement("div", {
    className: `
        location-select__option
        ${firstInGroup || isPopularHeader ? 'location-select__option--first-in-group' : ''}
        ${fieldValue.value === value && fieldValue.Name === Name ? 'location-select__option--is-selected' : ''}
        ${popularItem ? 'location-select__option--popular' : ''}
      `,
    onClick: () => {
      setValue(locationProps);
      setIsOpened(false);
    }
  }, firstInGroup && /*#__PURE__*/React.createElement("div", {
    className: "location-select__group-heading"
  }, groupLabel), isPopularHeader && /*#__PURE__*/React.createElement("div", {
    className: "location-select__group-heading"
  }, mostPopularText), /*#__PURE__*/React.createElement("div", {
    className: `location-select__option-names ${asAMetroChild ? 'location-select__option-names--metro-child' : ''}`
  }, /*#__PURE__*/React.createElement("h6", {
    className: "is-ellipsed"
  }, city, ", ", country), /*#__PURE__*/React.createElement("p", {
    className: "is-ellipsed"
  }, rtl ? /*#__PURE__*/React.createElement(IconEnterLeft, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconEnterRight, {
    className: "icon"
  }), " ", Name)), /*#__PURE__*/React.createElement("span", {
    className: "location-select__option-code"
  }, airportCode));
};
const LocationSelect = _ref2 => {
  let {
    rtl,
    isMobile,
    isOpened,
    setIsOpened,
    departureField,
    headerText,
    fromValue,
    toValue,
    fieldValue,
    locationsList,
    inputValue,
    setInputValue,
    setMyLocation,
    clearField,
    setValue,
    focusedOnce,
    setFocusedOnce,
    textClear,
    fromText,
    toText,
    labelText,
    labelHelpText,
    useCurrentLocationText,
    loadNMoreDestinationsText,
    mostPopularText,
    mobilePlaceholder,
    error,
    errorEmptyText,
    errorInvalidText,
    invalidFilter,
    setInvalidFilter
  } = _ref2;
  const inputTextRef = useRef(false);
  const inputDeskTextRef = useRef(false);
  const locationsListRef = useRef(false);
  const [startedUtocomplete, setStartedAutocomplete] = useState(false);
  const [deskFieldHighlighted, setDeskFieldHighlighted] = useState(false);
  const deskFieldClickedRef = useRef(false);
  const optionsNumber = locationsList.length;
  const loadMoreButtonText = loadNMoreDestinationsText.replace('%n%', String(optionsNumber - 20));
  const componentPrefix = departureField ? 'departure' : 'destination';
  useEffect(() => {
    if (isOpened) {
      if (isMobile) {
        if (inputTextRef.current) inputTextRef.current.focus();
      } else {
        deskFieldClickedRef.current = true;
        if (inputDeskTextRef.current) inputDeskTextRef.current.focus();
      }
    }
  }, [isOpened, isMobile]);
  useEffect(() => {
    if (!isOpened) {
      locationsListRef.current.scrollTo(0, 0);
      setStartedAutocomplete(false);
    }
  }, [isOpened]);
  useEffect(() => {
    if (inputValue && !startedUtocomplete) {
      setStartedAutocomplete(true);
    }
  }, [inputValue]);
  const renderFiltered = () => {
    let currentLabel = '';

    /* Filtering method */
    const filterList = locationItem => {
      if (locationItem.popularItem) {
        return null;
      }
      if (locationItem.city.toLowerCase().startsWith(inputValue.toLowerCase())) {
        const {
            asAMetroChild,
            firstInGroup
          } = locationItem,
          formatted = _objectWithoutProperties(locationItem, _excluded2);
        return {
          category: 'starters',
          value: formatted
        };
      }
      if (locationItem.city.toLowerCase().includes(inputValue.toLowerCase()) || locationItem.country.toLowerCase().includes(inputValue.toLowerCase())) {
        const {
            asAMetroChild,
            firstInGroup
          } = locationItem,
          formatted = _objectWithoutProperties(locationItem, _excluded3);
        if (locationItem.groupLabel !== currentLabel) {
          currentLabel = locationItem.groupLabel;
          formatted.firstInGroup = true;
        }
        return {
          category: 'others',
          value: formatted
        };
      }
      return null;
    };
    const result = locationsList.reduce((acc, item) => {
      const filtered = filterList(item);
      if (filtered) {
        acc[filtered.category].push(filtered.value);
      }
      return acc;
    }, {
      starters: [],
      others: []
    });
    const final = [...result.starters, ...result.others];
    setInvalidFilter(!(!!final.length && inputValue));
    return final.map(item => /*#__PURE__*/React.createElement(AirprtItem, _extends({
      key: `results-${componentPrefix}-${item.value}-${item.Name}`,
      mostPopularText: mostPopularText,
      setValue: setValue,
      setIsOpened: setIsOpened,
      fieldValue: fieldValue
    }, item)));
  };
  const deskFieldFocusHandler = () => {
    setIsOpened(true);
    if (!focusedOnce) {
      setFocusedOnce();
    }
    if (!deskFieldClickedRef.current) {
      setDeskFieldHighlighted(true);
    }
  };
  const deskFieldDownkHandler = () => {
    deskFieldClickedRef.current = true;
  };
  const deskFieldBlurHandler = () => {
    deskFieldClickedRef.current = false;
    setDeskFieldHighlighted(false);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement(React.Fragment, null, optionsNumber ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-md-none",
    tabIndex: 0,
    onClick: () => {
      setIsOpened(true);
      if (!focusedOnce) setFocusedOnce();
    }
  }, fieldValue.value ? /*#__PURE__*/React.createElement("div", {
    className: "city-selector__mobile-value"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "city-selector__value-head is-ellipsed"
  }, fieldValue.city), /*#__PURE__*/React.createElement("p", {
    className: "city-selector__value-subhead is-ellipsed"
  }, fieldValue.Name, " ", fieldValue.airportCode)) : /*#__PURE__*/React.createElement("span", {
    className: "city-selector__mobile-label"
  }, labelText)), /*#__PURE__*/React.createElement("div", {
    className: `
              city-selector__desc d-none d-md-block
              ${focusedOnce || fieldValue.value ? '' : 'city-selector__desc--untouched'}
            `
  }, /*#__PURE__*/React.createElement("span", {
    className: "city-selector__desc-label"
  }, labelText), focusedOnce || fieldValue.value ? null : /*#__PURE__*/React.createElement("span", {
    className: "city-selector__desc-help-label is-ellipsed"
  }, labelHelpText), fieldValue.value && /*#__PURE__*/React.createElement("div", {
    className: "city-selector__desc-value"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "city-selector__value-head is-ellipsed"
  }, fieldValue.city), /*#__PURE__*/React.createElement("p", {
    className: "city-selector__value-subhead is-ellipsed"
  }, fieldValue.Name, " ", fieldValue.airportCode)), /*#__PURE__*/React.createElement("input", {
    value: inputValue,
    onChange: e => {
      setInputValue(e.target.value);
    },
    onFocus: deskFieldFocusHandler,
    onMouseDown: deskFieldDownkHandler,
    onBlur: deskFieldBlurHandler,
    type: "text",
    className: `${deskFieldHighlighted ? 'field--focused' : ''} city-selector__input`,
    ref: inputDeskTextRef
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-md-none"
  }, /*#__PURE__*/React.createElement("span", {
    className: "city-selector__mobile-label"
  }, labelText)), /*#__PURE__*/React.createElement("div", {
    className: "city-selector__desc d-none d-md-block city-selector__desc--untouched"
  }, /*#__PURE__*/React.createElement("span", {
    className: "city-selector__desc-label"
  }, labelText), /*#__PURE__*/React.createElement("span", {
    className: "city-selector__desc-help-label is-ellipsed"
  }, labelHelpText))), error && /*#__PURE__*/React.createElement("div", {
    className: `fields-wrapper__dest-error is-ellipsed`
  }, inputValue ? errorInvalidText : errorEmptyText), /*#__PURE__*/React.createElement("div", {
    className: `
          location-select
          ${isOpened && optionsNumber ? '' : 'location-select--hidden'}
          ${invalidFilter ? 'location-select--filter-invalid' : ''}
          ${!!inputValue ? 'location-select--filter-processed' : ''}
        `
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-md-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: () => {
      setIsOpened(false);
    }
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, headerText), !departureField && clearField && /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: () => {
      clearField();
    }
  }, textClear)), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none dropdown-state-area"
  }, /*#__PURE__*/React.createElement("div", {
    className: `dropdown-state-area__cell`
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: `dropdown-state-area__label ${fromValue ? 'dropdown-state-area__label--selected' : ''}`
  }, fromText), fromValue ? /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__city"
  }, fromValue) : null)), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__plane-icon"
  }, /*#__PURE__*/React.createElement(IconPlane, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: `dropdown-state-area__cell`
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: `dropdown-state-area__label ${toValue ? 'dropdown-state-area__label--selected' : ''}`
  }, toText), toValue ? /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__city"
  }, toValue) : null))), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none location-select__autocomplete-wrapper"
  }, /*#__PURE__*/React.createElement("input", {
    ref: inputTextRef,
    type: "text",
    className: "location-select__autocomplete-field",
    value: inputValue,
    onChange: e => {
      setInputValue(e.target.value);
    },
    placeholder: mobilePlaceholder
  })), departureField && setMyLocation && /*#__PURE__*/React.createElement("button", {
    className: "location-select__locator-btn",
    onClick: () => {
      setMyLocation();
    }
  }, useCurrentLocationText, " ", /*#__PURE__*/React.createElement(MyLocationIcon, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: `
            location-select__body
            ${startedUtocomplete ? 'location-select__body--disabled-loadmore location-select__body--disabled-populars' : ''}
          `,
    ref: locationsListRef
  }, /*#__PURE__*/React.createElement(Destinations, {
    buttonText: loadMoreButtonText,
    optionsNumber: optionsNumber,
    dropDownOpened: isOpened
  }, !!inputValue ? renderFiltered() : locationsList.map(location => {
    const isPopularPrefix = location.popularItem ? 'popular-' : '';
    return /*#__PURE__*/React.createElement(AirprtItem, _extends({
      key: `${isPopularPrefix}${componentPrefix}-${location.value}-${location.Name}`,
      mostPopularText: mostPopularText,
      setValue: setValue,
      setIsOpened: setIsOpened,
      fieldValue: fieldValue
    }, location));
  }))))));
};
const commonStyles = "c1r5g8l3";
const ltrStyles = "l1mw5ww3";
const rtlStyles = "r1o4fb68";
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export default LocationSelect;